module.exports = __webpack_public_path__ + "img/BM.88a65dae.png";